import {
    Component,
    DestroyRef,
    EventEmitter,
    inject,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import {ModelService} from '../../Services/model.service';
import {Product} from '../../Model/Catalog/Product';
import {Catalog} from '../../Model/Catalog/Catalog';
import {Message} from '../../Model/System/Message';
import {TranslateService} from '@ngx-translate/core';
import {AddClassification} from '../../Model/classification/AddClassification';
import {FeatureSystem} from '../../Model/Catalog/FeatureModels/FeatureSystem';
import {FeatureValueContainer} from '../../Model/classification/FeatureValueContainer';
import {UserManagementService} from '../../Services/userManagment.service';
import {MassDataChangeService} from '../../Services/CatalogManagement/massDataChange.service';
import {CatalogService} from '../../Services/CatalogManagement/catalog.service';
import {InvoiceService} from '../../Services/invoice.service';
import {TeachingSet} from '../../Model/OpenAi/teachingset';
import {TeachingSetService} from '../../Services/teachingSet.service';
import {ValidationService} from '../../Services/Validation/validation.service';
import {lastValueFrom, Subscription} from 'rxjs';
import {ClassificationClass} from '../../Model/classification/ClassificationClass';
import {ClassificationService} from '../../Services/classification.service';
import {AiPromptsService} from 'app/Services/aiprompt.service';
import {NpInputControlContext} from "../../ui/inputControl/np-input-control-context";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
  selector: 'productDetail',
  templateUrl: 'productDetail.component.html',
  styleUrls: ['./../shared/detail.css', 'productDetail.component.css'],
    providers: [{provide: NpInputControlContext, useClass: NpInputControlContext}],
  standalone: false
})
export class ProductDetailComponent implements OnInit, OnChanges, OnDestroy {
    private context = inject(NpInputControlContext);
    @Output() onMassDataEdit = new EventEmitter<Product>();

    confirmVisible: boolean = false;
    teachingSet: TeachingSet;
    teachingSets: TeachingSet[];
    generateHTML = false;
    textstyle: string = 'werblich';
    maxLength: number = 2000;
    textstyles: string[] = new Array<string>();

    private destroyRef = inject(DestroyRef);

    get isOnboarding() {
        return this.modelService.loginService.hasAddonONBOARDING;
    }

    constructor(
        public modelService: ModelService,
        public translate: TranslateService,
        public validationService: ValidationService,
        public userManagement: UserManagementService,
        public massDataService: MassDataChangeService,
        public catalogService: CatalogService,
        public invoiceService: InvoiceService,
        public teachingSetService: TeachingSetService,
        private classificationService: ClassificationService,
        public aiPromptService: AiPromptsService
    ) {
        this.goToSourceProduct = this.goToSourceProduct.bind(this);
        this.goToMasterProduct = this.goToMasterProduct.bind(this);
        this.openMassDataChange = this.openMassDataChange.bind(this);
        this.isMaster = this.isMaster.bind(this);
        this.generateKiText = this.generateKiText.bind(this);
        this.openConfirm = this.openConfirm.bind(this);
        this.share = this.share.bind(this);
        this.descWizardReload = this.descWizardReload.bind(this);
    }

    async ngOnInit() {
        this.updateInputControlContext();
        this.translateTexts();
        this.catalogService.productChanged.subscribe((product) => {
            this.updateInputControlContext()
        });
        this.reset();

        this.context.valueChanged.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x => this.productUpdate(x));
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.updateInputControlContext();
    }

    ngOnDestroy(): void {
    }

    private updateInputControlContext() {
        this.context.model = this.model;
        this.context.showDragHandle = false;
        this.context.showLinkButtons = true;

    }

    isVirtualCatalog(): boolean {
        return this.modelService?.catalogService?.catalog?.isVirtual;
    }

    hasSourceProduct(): boolean {
        return this.model.sourceProductId != undefined;
    }

    hasMasterProduct(): boolean {
        return this.model.isChild === true
            && this.model.parentProductId != undefined
            && this.model.parentProductId != '';
    }

    thinkingVisible: boolean = false;
    txtProdukt: string;
    txtMedien: string;
    txtTexts: string;
    txtUdx: string;
    txtFeatures: string;
    txtPreislisten: string;
    txtSEO: string;
    txtLogistik: string;
    txtReferenzen: string;
    txtProduktUnbekannt: string;
    txtCategories: string;
    txtChange: string;
    txtLegal: string;
    txtOrderDetail: string;
    txtProductAsJson: string;
    txtSuppliers: string;
    txtElectronicSales: string;
    txtShopware6Configuration: string;
    txtScireumSellsite: string;
    txtSellThroughFigures: string;
    txtDisplay: string;
    txtDpb: string;

    translateTexts() {
        this.txtProdukt = this.translate.instant('Produkt');
        this.txtMedien = this.translate.instant('Medien');
        this.txtTexts = this.translate.instant('Texte');
        this.txtUdx = this.translate.instant('Zusatzfelder');
        this.txtFeatures = this.translate.instant('Merkmale');
        this.txtPreislisten = this.translate.instant('Preislisten');
        this.txtOrderDetail = this.translate.instant('Bestelldetails');
        this.txtSEO = this.translate.instant('SEO - SEA');
        this.txtLogistik = this.translate.instant('Logistik');
        this.txtReferenzen = this.translate.instant('Referenzen');
        this.txtProduktUnbekannt = this.translate.instant('Produkt unbekannt');
        this.txtCategories = this.translate.instant('Kategorien');
        this.txtLegal = this.translate.instant('Recht');
        this.txtProductAsJson = this.translate.instant('JSON');
        this.txtSuppliers = this.translate.instant('Lieferanten');
        this.txtElectronicSales = this.translate.instant('ElectronicSales');
        this.txtShopware6Configuration = this.translate.instant('Shopware6');
        this.txtScireumSellsite = this.translate.instant("SCIREUM_SELLSITE");
        this.txtSellThroughFigures = this.translate.instant("Abverkaufszahlen");
        this.txtDisplay = this.translate.instant('Display');
        this.txtDpb = this.translate.instant('DPB');
    }

    reset() {
        if (this.modelService.catalogService.catalog.usePrintView) {
            this.pages = [
                { id: 1, title: this.txtProdukt, template: 'productTemplate', type: 'MAIN' },
                { id: 2, title: this.txtTexts, template: 'textsTemplate', type: 'TEXTS'},
                { id: 3, title: this.txtMedien, template: 'medienTemplate', type: 'MIME'},
                { id: 4, title: this.txtFeatures, template: 'featuresTemplate', type: 'FEAT' },
                { id: 5, title: this.txtOrderDetail, template: 'orderDetailTemplate', type: 'ORDER' },
                { id: 6, title: this.txtPreislisten, template: 'preislistenTemplate', type: 'PRICE' },
                { id: 10, title: this.txtCategories, template: 'categoriesTemplate', type: 'CAT' }
            ];
        } else {
            this.pages = [
                { id: 1, title: this.txtProdukt, template: 'productTemplate', type: 'MAIN' },
                { id: 2, title: this.txtTexts, template: 'textsTemplate', type: 'TEXTS'},
                { id: 3, title: this.txtMedien, template: 'medienTemplate', type: 'MIME'},
                { id: 4, title: this.txtFeatures, template: 'featuresTemplate', type: 'FEAT' },
                { id: 5, title: this.txtOrderDetail, template: 'orderDetailTemplate', type: 'ORDER' },
                { id: 6, title: this.txtPreislisten, template: 'preislistenTemplate', type: 'PRICE' },
                { id: 7, title: this.txtLogistik, template: 'logistikTemplate', type: 'LOGI' },
                { id: 8, title: this.txtReferenzen, template: 'referenceTemplate', type: 'REFE' },
                { id: 9, title: this.txtCategories, template: 'categoriesTemplate', type: 'CAT' }
            ];

            if (this.modelService.loginService.hasAddonUDX) {
                this.pages.push({ id: 10, title: this.txtUdx, template: 'udxTemplate', type: 'UDX' });
            }

            this.pages.push({ id: 12, title: this.txtLegal, template: 'legalTemplate', type: 'LEGAL' });

            if (this.modelService.loginService.hasAddonElectronicSales) {
                this.pages.push({
                    id: 13,
                    title: this.txtElectronicSales,
                    template: 'electronicSalesTemplate',
                    type: 'ESALES'
                });
            }
            if (this.modelService.loginService.hasAddonWawiErp &&
              (this.modelService.loginService.wawiSettings?.customFields?.filter(x => x.tabOption === "Wawi" && !x.customTabId).length > 0 ||
                this.modelService.loginService.wawiSettings?.line1TabOption == "Wawi" ||
                this.modelService.loginService.wawiSettings?.line2TabOption == "Wawi" ||
                this.modelService.loginService.wawiSettings?.line3TabOption == "Wawi" ||
                this.modelService.loginService.wawiSettings?.line4TabOption == "Wawi")) {
              this.pages.push({
                id: 14,
                title: this.modelService.loginService.wawiSettings.name,
                template: 'wawiTemplate',
                type: 'WAWI'
              });
            }
            if (this.modelService.loginService.hasAddonWawiErp && this.modelService.loginService.wawiSettings?.customTabs) {
              for (const tab of this.modelService.loginService.wawiSettings.customTabs) {
                if (this.modelService.loginService.wawiSettings.customFields?.some(x => x.customTabId === tab.id)) {
                  this.pages.push({
                    id: 1000 + tab.id,
                    title: tab.name,
                    template: 'customTabTemplate',
                    type: 'CUSTOMTAB',
                    tabKey: 'tab:' + tab.id
                  });
                }
              }
            }
            if (this.modelService.loginService.hasAddonSUPPLIERS) {
                this.pages.push({
                    id: 15,
                    title: this.txtSuppliers,
                    template: 'productSuppliersTemplate',
                    type: 'SUPP'
                });
            }
            if (this.modelService.loginService.hasAddonShopware6) {
                this.pages.push({
                    id: 16,
                    title: this.txtShopware6Configuration,
                    template: 'shopware6Template',
                    type: 'SW'
                });
            }
            if (this.modelService.loginService.hasAddonScireumSellsite) {
                this.pages.push({ id: 17, title: this.txtScireumSellsite, template: "scireumSellsiteTemplate", type: "SCI" });
            }

            if(this.modelService.loginService.hasAddonBauvista) {
              this.pages.push({ id: 18, title: this.txtSellThroughFigures, template: "sellThroughFigures", type: "STF" });
              this.pages.push({ id: 20, title: this.txtDisplay, template: 'displayTemplate', type: 'DISP' });
            }

            if (this.modelService.loginService.hasAddonDpbImport || this.modelService.loginService.hasAddonDpbExport) {
              this.pages.push({ id: 21, title: this.txtDpb, template: 'dpbTemplate', type: 'DPB' });
            }
            
            if (this.modelService.loginService.hasAddonDEVELOPMENT) {
                this.pages.push({
                    id: 19,
                    title: this.txtProductAsJson,
                    template: "productAsJsonTemplate",
                    type: "JSON"
                });
            }
        }
        this.textstyles = new Array<string>();
        this.textstyles.push('werblich');
        this.textstyles.push('technisch');
        this.textstyles.push('beschreibend');
    }

    hasCatalogMappings(model: Product): boolean {
        if (model.catalogMappings && model.catalogMappings[1]) return true;
        return false;
    }

    pages: { id: number; title: string; template: string; type: string; tabKey?: string }[] = [];
    currentPageType: string = 'MAIN';

    get model(): Product {
        return this.modelService.catalogService.product;
    }

    set model(product: Product) {
        this.modelService.catalogService.product = product;
        this.validationService.validateProduct(this.modelService.catalogService.product);
    }

    openShopView() {
        this.modelService.hazmatClassService.loadProductHazmat(this.model);
        this.modelService.warrantyClassService.loadProductWarranty(this.model);
        this.validationService.validateProduct(this.modelService.catalogService.product);
        this.showShop = true;
    }

    async addClassificationFeatures(event: ClassificationClass) {
        if (!event) return;
        let dto = new AddClassification();
        dto.classificationClassId = event.id;
        dto.classificationSystemId = event.classificationSystemId;
        dto.customerId = this.modelService.catalogService.product.customerId;
        dto.productId = this.modelService.catalogService.product.id;

        var featureSystems = await this.classificationService.addClassificationFeatures(dto);
        this.modelService.catalogService.product.featureSystems = new Array<FeatureSystem>();

        let that = this;
        featureSystems.forEach(function (r) {
            let fs = Object.assign(new FeatureSystem(), r);
            that.modelService.catalogService.product.featureSystems.push(fs);
        });
        await this.validationService.validateProductPromise(this.model);
    }

    get showShop(): boolean {
        return this.modelService.systemService.showShop;
    }

    set showShop(value) {
        this.modelService.systemService.showShop = value;
    }

    get shopViewModel() {
        if (this.modelService.translationService.productTranslation != null)
            return this.modelService.translationService.productTranslation;
        return this.model;
    }

    public tabChange(event) {
        if (this.model.hintsActiv) {
            this.modelService.catalogService.validateProductForm(event.itemData.type);
        }
        this.currentPageType = event.itemData.type;
    }

    //ProductInfos
    public translationUpdateFunctions(params) {
        if (params.txtOrg == '' || params.txtOrg == null) {
            this.translate.get('Ohne deutschen Eintrag, ist keine Übersetzung möglich').subscribe((text: string) => {
                this.modelService.systemService.notify(new Message(text, 'error'));
            });

            return;
        }
        this.modelService.translationService.translationUpdate(params.txtOrg, params.txtTran);
    }

    //Reload Product z.b. für Mimes
    reload() {
        this.modelService.catalogService.treeRefresh();
        this.modelService.catalogService
            .getProduct(
                this.model.id,
                this.modelService.loginService.currentUser.customerId,
                this.modelService.catalogService.catalog.id
            )
            .subscribe(() => {
                this.updateInputControlContext();
                this.validationService.validateProduct(this.modelService.catalogService.product);
            });
    }

    productUpdate(event = null) {
        try {
            this.modelService.catalogService
                .updateProduct(event)
                .then(() => {
                    this.validationService.validateProductPromise(this.model).then(() => {
                    });
                    if (event === 'reload') {
                        this.reload();
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        } catch (error) {
            console.log('error' + error);
        }
    }

    get productMainImage(): string {
        if (
            this.modelService.catalogService.product != null &&
            this.modelService.catalogService.product.mimes &&
            this.modelService.catalogService.product.mimes.length > 0
        ) {
            for (mime of this.modelService.catalogService.product.mimes) {
                if (mime.mimePurpose == 'normal')
                    if (mime.normUri || mime.externalImageUrl) {
                        return mime.normUri || mime.externalImageUrl;
                    }
            }

            var mime = this.modelService.catalogService.product.mimes[0];
            return mime.normUri || mime.externalImageUrl || null;
        }
        return null;
    }

    //Referencen nachladen
    onReferencePrepare(event) {
        if (event.columnIndex == 3 && event.rowType == 'data') {
            if (event.data.artIdTo != null) {
                this.modelService.catalogService
                    .getProductBySupplierPid(
                        event.data.artIdTo,
                        this.modelService.loginService.currentUser.customerId,
                        this.modelService.catalogService.catalog.id
                    )
                    .subscribe(
                        (result) => {
                            event.data.descriptionShort = result.descriptionShort;
                            for (let mime of result.mimes.sort((a, b) => (a.mimeOrder > b.mimeOrder ? 1 : -1))) {
                                if (mime.mimePurpose == 'normal' && mime.normUri != null) {
                                    event.data.normUri = mime.normUri;
                                }
                            }
                        },
                        (error) => {
                            event.data.descriptionShort = '';
                            event.data.normUri = '';
                        }
                    );
            } else {
                event.data.descriptionShort = '';
                event.data.normUri = '';
            }
        }
    }

    public validateProductForm() {
        this.modelService.catalogService.validateProductForm(this.currentPageType);
    }

    public openProductView() {
        //let catalogId = "";
        //if (this.model.catalogMappings.length > 0) {
        //  catalogId = this.model.catalogMappings[0].catalogId;
        //} else {
        let catalogId = this.modelService.catalogService.selectedCatalogId;
        //}

        //this.modelService.router.navigate([
        //  "/getProduct", {
        //    queryParams: { catalogId: catalogId, customerId: this.model.customerId, supplierPid: this.model.supplierPid }
        //  }]);
        window.open(
            '/getProduct?catalogId=' +
            catalogId +
            '&customerId=' +
            this.model.customerId +
            '&supplierPid=' +
            this.model.supplierPid
        );
    }

    get bigHeader() {
        if (window) {
            return window.innerHeight > 1000;
        }
        return true;
    }

    addEcommerceFeatures() {
        this.modelService.catalogService.addEcommerceFeatures(this.model).subscribe((product: Product) => {
            this.model.featureSystems = product.featureSystems;
            //this.isClassificationVisible = false;
        });
    }

    public classificationFeatureValues: FeatureValueContainer = {};

    get showToolTips(): boolean {
        return this.modelService.loginService.showToolTips;
    }

    get showProToolTips(): boolean {
        return this.modelService.loginService.showProToolTips;
    }

    get showPlaceHolders() {
        return this.modelService.loginService.showPlaceHolders;
    }

    canView(name: string): boolean {
        return this.userManagement.canView(name);
    }

    readOnlyUser(name: string, catalog: Catalog = this.catalogService.catalog): boolean {
        return !this.userManagement.canEdit(name, catalog);
    }

    isMaster(): boolean {
        return this.model.productCount > 0;
    }

    openMassDataChange() {
        this.massDataService
            .getEmtpyProductByMasterProduct(this.catalogService.catalog.id, this.modelService.catalogService.product.id)
            .subscribe((result: Product) => {
                this.onMassDataEdit.emit(
                    this.modelService.productService.getProductFromJson(result, this.modelService.loginService.wawiSettings)
                );
            });
    }

    generateKiText() {
        this.thinkingVisible = true;
        this.invoiceService.GetInvoiceSetting(this.modelService.loginService.currentCustomer.id).subscribe((setting) => {
            if (setting.usedLimit + setting.pricePerOpenAi > setting.limit) {
                this.modelService.systemService.notifyWarning('Diese Operation würde ihr festgelegtes Limit übersteigen');
                this.thinkingVisible = false;
                return;
            }
            let teachingset = this.teachingSet != null ? this.teachingSet.id : '';
            this.modelService.catalogService
                .getProductWithGeneratedText(
                    this.modelService.catalogService.product,
                    this.modelService.catalogService.catalog.catalogName,
                    teachingset,
                    this.generateHTML,
                    this.maxLength,
                    this.textstyle
                )
                .subscribe((result: Product) => {
                    this.reload();
                    this.thinkingVisible = false;
                });
        });
    }

    async goToSourceProduct() {
        var currentProduct = this.modelService.catalogService.product;
        var relevantProductId = this.hasSourceProduct() ? this.model.sourceProductId : currentProduct.id;

        var product = await lastValueFrom(
            this.catalogService.getProduct(relevantProductId, this.model.customerId, '')
        ).catch((err) => {
        });
        if (!product) {
            this.modelService.systemService.notifyWarning('Das QuellProdukt wurde nicht gefunden.');
            return;
        }

        var nonVirtualCatalogMapping = product.catalogMappings.find((x) => !x.isVirtualCatalog);
        if (!nonVirtualCatalogMapping) {
            this.modelService.systemService.notifyWarning('Es wurde kein nichtvritueller Katalog zum QuellProdukt gefunden.');
            return;
        }
        var navigateString =
            '/catalog/' + this.model.customerId + '/' + nonVirtualCatalogMapping.catalogId + '/product/' + product.id;
        this.modelService.catalogService.selectedCatalogId = nonVirtualCatalogMapping.catalogId;
        this.modelService.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => this.modelService.router.navigate([navigateString]));
        return;
    }

    async goToMasterProduct() {
        var master = await lastValueFrom(
            this.catalogService.getProduct(this.model.parentProductId, this.model.customerId, '')
        ).catch((err) => {
        });
        if (!master) {
            this.modelService.systemService.notifyWarning('Das Masterprodukt wurde nicht gefunden.');
            return;
        }

        var nonVirtualCatalogMapping = master.catalogMappings.find((x) => !x.isVirtualCatalog);
        if (!nonVirtualCatalogMapping) {
            this.modelService.systemService.notifyWarning('Es wurde kein nichtvirtueller Katalog zum Masterprodukt gefunden.');
            return;
        }
        var navigateString =
            '/catalog/' + this.model.customerId + '/' + nonVirtualCatalogMapping.catalogId + '/product/' + master.id;
        var masterSupplierPid = master.supplierPid;
        this.modelService.catalogService.selectedCatalogId = nonVirtualCatalogMapping.catalogId;
        this.modelService.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => this.modelService.router.navigate([navigateString], { queryParams: { search: masterSupplierPid } }));
    }

    async openConfirm() {
        this.confirmVisible = true;
    }


    share() {
        let catalogId = this.modelService.catalogService.selectedCatalogId;
        let categoryId = '';
        if (this.model.catalogMappings.length > 0) {
            categoryId = this.model.catalogMappings[0].categoryId;
        }
        //this.clipboard.copy("/catalog/" + catalogId + "/" + this.model.supplierPid);
        window.open(
            '/catalog/' +
            this.modelService.loginService.currentCustomer.id +
            '/' +
            catalogId +
            '/' +
            categoryId +
            '/' +
            this.model.id
        );
    }

    descWizardReload() {
        this.confirmVisible = false;
        this.reload();
    }

}
